<!--  -->
<template>
  <div class="workOrder-main">
    <div class="title">提交工单</div>
    <h-form
      ref="formRefs"
      :model="formItem"
      :label-width="138"
      style="padding-bottom: 96px;"
      :rules="ruleCustom"
    >
      <h-form-item style="margin-bottom: 0">
        <h-alert type="info" show-icon
          >如果您想提需求，请<a href="/online-console/requirementAdd"
            >点击这里</a
          ></h-alert
        >
      </h-form-item>
      <h-form-item
        label="请选择提交类型"
        required
        class="type"
        prop="feedback_type"
      >
        <h-radio-group v-model="formItem.feedback_type">
          <div
            class="workOrder-box"
            :class="{ selected: formItem.feedback_type === '1' }"
            @click="changeType('1')"
          >
            <h-radio label="1">意见和建议</h-radio>
            <!-- <p>需要什么新的服务或者定制化产品</p> -->
          </div>
          <div
            class="workOrder-box"
            :class="{ selected: formItem.feedback_type === '2' }"
            @click="changeType('2')"
          >
            <h-radio label="2">日常服务</h-radio>
            <!-- <p>需要什么新的服务或者定制化产品</p> -->
          </div>
        </h-radio-group>
      </h-form-item>
      <h-form-item label="简述问题" required prop="problems_desc">
        <h-input
          v-model.trim="formItem.problems_desc"
          placeholder="请简要概括内容"
          :maxlength="50"
        ></h-input>
      </h-form-item>
      <h-form-item label="选择产品" prop="involve_product_id">
        <h-select
          :label="formItem.involve_product"
          v-model="formItem.involve_product_id"
          placeholder="请输入相关产品名称"
          clearable
          ref="serviceRef"
          filterable
          remote
          :remote-method="queryServiceComboxList"
          label-in-value
          :allowCreate="submitType === '1'"
          @on-change="getvaluelabel"
        >
          <h-option
            v-for="(item, index) in queryProductList"
            :value="item.service_id"
            :key="index"
            :label="item.service_name"
          ></h-option>
        </h-select>
      </h-form-item>
      <div class="kj-box">
        <span class="title">快捷选择</span>
        <ul>
          <template v-for="(val, index) in productList">
            <li
              :key="'service' + index"
              :title="val.service_name"
              v-if="index < 8"
              :class="
                formItem.involve_product === val.service_id ? 'select' : ''
              "
              @click="kjSelectServce(val)"
            >
              {{ val.service_name }}
            </li>
          </template>
        </ul>
      </div>
      <h-form-item label="详细描述" required prop="content">
        <h-input
          v-model="formItem.content"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5 }"
          placeholder="请具体描述需求内容"
          :maxlength="500"
          showWordLimit
        ></h-input>
      </h-form-item>
      <h-form-item label="联系人" required prop="contact_name">
        <h-input
          v-model.trim="formItem.contact_name"
          placeholder="请输入联系人"
          :maxlength="50"
        ></h-input>
      </h-form-item>
      <h-form-item label="联系电话" required prop="contact_phone">
        <h-input
          v-model="formItem.contact_phone"
          placeholder="请输入联系电话"
        ></h-input>
        <p class="tip">若您是代客提交可自行更改联系人和联系电话</p>
      </h-form-item>
      <h-form-item label="上传附件" prop="remark" cols="2">
        <upload-item ref="uploadItem" name="上传附件"></upload-item>
        <p class="tip">
          选择文件，允许文件类型:xls、xlsx、rar、zip、png、jpg、jpeg、pdf、doc，不超过5mb
        </p>
      </h-form-item>
      <h-form-item>
        <h-button type="primary" @click="ok" :disabled="btnState || btnState1"
          >提交工单</h-button
        >
      </h-form-item>
    </h-form>
  </div>
</template>

<script>
import { getCamelCase } from "@/utils";
import { mapGetters } from "vuex";
import UploadItem from "@/views/frontViews/uploadItem";
import {
  queryFeedBackServiceComboxList,
  queryTopServiceInfoList
} from "@/api/submitWorkOrderApi/submitWorkOrder.js";
import _ from "lodash";
import axios from "axios";
// import { getUrlParam } from "@/utils";

export default {
  components: {
    UploadItem
  },
  data() {
    const isMobile = value => {
      let patrn = /^0(\d{2,3})-?\d{7,8}(-\d{1,5}){0,3}$|^1\d{10}$|^852-?[2689]\d{7}$|^852-?3[014-9]\d{6}$|^852-?3[23]\d{7}$|^852-?5[0-578]\d{6}$|^852-?5[69]\d{7}$|^853-?[1-9]\d{7}$/;
      if (value === "" || value === null) {
        return false;
      } else if (!patrn.exec(value)) {
        return false;
      }
      return true;
    };
    return {
      /**
       * btnState1: 控制工单不能重复提交
       */
      submitType: "1", // 提交工单类型 '1'为意见和建议  '2' 为日常服务
      successShow: false,
      formItem: {
        feedback_type: "1",
        problems_desc: "",
        involve_product: "",
        content: "",
        contact_name: "",
        contact_phone: "",
        involve_product_id: "",
        remark:''
      },
      productList: [],
      queryProductList: [],
      currentValue: {}, // 选择产品下拉框的当前选中项
      query: "", // 选择产品下拉框的搜索关键词
      textarea: "",
      btnState1: false,
      ruleCustom: {
        content: [
          {
            validator: (rule, value, callback) => {
              if (!value.trim()) {
                this.formItem.content = "";
                callback("输入不能为空");
              } else {
                this.formItem.content = value.trim();
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        contact_phone: [
          {
            validator: (rule, value, callback) => {
              if (!isMobile(value)) {
                callback("请输入正确的联系电话");
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["user", "loginInfo"]),
    // 表单填写完整时登录按钮变蓝
    btnState() {
      //当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
      if (this.submitType === "1") {
        if (
          !(
            this.formItem.feedback_type &&
            this.formItem.feedback_type !== "" &&
            this.formItem.problems_desc &&
            this.formItem.problems_desc !== "" &&
            this.formItem.content &&
            this.formItem.content !== "" &&
            this.formItem.contact_name &&
            this.formItem.contact_name !== "" &&
            this.formItem.contact_phone &&
            this.formItem.contact_phone !== ""
          )
        )
          return true;
        else return false;
      } else {
        if (
          !(
            this.formItem.feedback_type &&
            this.formItem.feedback_type !== "" &&
            this.formItem.problems_desc &&
            this.formItem.problems_desc !== "" &&
            this.formItem.content &&
            this.formItem.content !== "" &&
            this.formItem.contact_name &&
            this.formItem.contact_name !== "" &&
            this.formItem.contact_phone &&
            this.formItem.contact_phone !== ""
          )
        )
          return true;
        else return false;
      }
    }
  },
  created() {
    const routerQuery = this.$route.query;
    if (routerQuery) {
      this.formItem = {
        ...this.formItem,
        ...routerQuery
      };
      if(this.formItem.involve_product_id&&!this.formItem.involve_product){
        this.formItem.involve_product = this.formItem.involve_product_id
      }
      if(this.formItem.involve_product){
        this.queryServiceComboxList(this.formItem.involve_product)
        this.getvaluelabel({
          label:this.formItem.involve_product,
          value:this.formItem.involve_product_id||this.formItem.involve_product
        })
      }

    }
  },
  mounted() {

    this.getMyList();
    this.serLoginInfo()
  },
  watch: {
  },
  methods: {
    serLoginInfo() {
      try {
        this.formItem.contact_name = this.loginInfo.personal_account.user_name;
        this.formItem.contact_phone = this.loginInfo.personal_account.contact_mobile_tel
          ? this.loginInfo.personal_account.contact_mobile_tel.split(",")[0]
          : "";
      } catch (e) {
        console.log(e);
      }
    },
    // 获取快捷选择列表
    getQuickProductList() {
      this.getMyList();
    },
    // 获取选择产品下拉框的当前选中项
    getvaluelabel(data) {
      let obj = {
        provider_id: "",
        service_id:data.value,
        service_name: data.label
      };
      // this.formItem.involve_product = this.formItem.involve_product_id;
      for (const item of this.productList) {
        if (item.service_name === data.label) {
          this.formItem.involve_product = item.service_id;
        }
        if (data.value != 0 && data.value == item.service_id) {
          obj.service_id = item.service_id;
          obj.service_name = item.service_name;
          obj.provider_id = item.provider_id;
          break;
        }
      }
      this.currentValue = obj;
    },
    // 远程查询产品下拉列表
    remoteQueryServiceList(query) {
      if (query === "") {
        this.queryProductList = [];
        return;
      }
      this.query = query;
      return new Promise((resolve, reject) => {
        queryFeedBackServiceComboxList({
          service_name: query
        }).then(res => {
          if (res !== undefined && res !== "" && res !== null) {
            this.queryProductList = res;
            this.queryProductList.forEach((item, index) => {
              this.$set(item, "key", index + "");
            });
            resolve();
          }
        });
      });
    },

    // 查询选择产品服务信息下拉列表
    queryServiceComboxList: _.debounce(function(q) {
      this.remoteQueryServiceList(q);
    }, 500),
    // 快捷选择
    kjSelectServce(data) {
      this.currentValue = data;
      this.queryProductList = [
        {
          service_id: data.service_id,
          service_name: data.service_name
        }
      ];
      this.$refs.serviceRef.query = data.service_name;
      this.formItem.involve_product = data.service_id;
      // this.$nextTick(() => {});
    },
    getMyList() {
      queryTopServiceInfoList({}).then(res => {
        if (res !== undefined && res !== "" && res !== null) {
          this.productList = res;
          this.productList.forEach((item, index) => {
            this.$set(item, "key", index + "");
          });
        }
      });
    },
    changeShow(val) {
      this.successShow = val;
    },
    changeType(type) {
      this.submitType = type;
      this.formItem.feedback_type = type;
    },
    ok() {
      let that = this;

      that.$refs.formRefs.validate(valid => {
        if (valid) {
          let formData = new FormData();
          let list = that.$refs.uploadItem.inputImgIlist;
          for (var i = 0; i < list.length; i++) {
            formData.append("file", list[i]);
          }
          formData.append("providerId", this.currentValue.provider_id);
          that.formItem.involve_product_id = this.currentValue.service_id||'';
          that.formItem.involve_product = this.currentValue.service_name;
          if(this.currentValue.service_id==this.currentValue.service_name){
            that.formItem.involve_product_id=""
          }
          for (let key in that.formItem) {
            formData.append(getCamelCase(key), that.formItem[key]);
          }
          if (this.$refs.serviceRef.query === "") {
            formData.set("involveProduct", "");
            formData.set("providerId", "");
          }
          this.btnState1 = true;
          axios({
            url:
              "/openplat-gateway/openplat/openplat-service-server/v/userFeedback/addInternalFeedback",
            data: formData,
            method: "post",
            headers: {
              "content-type": "multipart/form-data",
              "Access-Token":
                sessionStorage.getItem("Access-Token") ||
                localStorage.getItem("Access-Token")
            },
            withCredentials: true
          })
            .then(res => {
              this.btnState1 = false;
              if (res.data.error_code && res.data.error_code == "100002") {
                that.$dialog.modal();
              } else if (res.data.error_code && res.data.error_code !== "0") {
                that.$hMessage.error(res.data.error_info, 3000);
              } else {
                that.$refs.formRefs.resetFields();
                that.successShow = true;
                // 如果是从光子中心跳转过来并且需要增加光子，那么在成功页面增加弹光子的动画
                // const response = res.data.data || {};
                // if (Number(response.memberSinglePointAmount)) {
                //   localStorage.setItem("isPhoton", "1");
                //   localStorage.setItem(
                //     "photon_num",
                //     response.memberSinglePointAmount || 0
                //   );
                // }
                that.$router.push("/workOrder/submitWorkOrderSuccess");
              }
            })
            .catch(error => {
              this.btnState1 = false;
            });
        } else this.btnState1 = false;
      });
      // this.btnState1 = true
    }
  }
};
</script>
<style lang="scss" scoped>
.submitWorkOrder-bg {
  background: url("~@/assets/submitWorkOrder/banner-1920.png") no-repeat top
    center;

  .workOrder-main {
    margin: auto;

    & > .title {
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      padding: 90px 0;
      letter-spacing: 4px;
      margin: 0;
    }

    .kj-box {
      display: flex;
      width: 100%;
      margin-top: -12px;
      margin-bottom: 16px;

      & > .title {
        width: 138px;
        text-align: right;
        padding-right: 16px;
        color: #999;
        line-height: 26px;
      }

      & > ul {
        display: flex;
        flex-wrap: wrap;
        width: 540px;
        text-align: center;

        li {
          width: 24%;
          margin-right: 7px;
          background: rgba(48, 96, 255, 0.08);
          border: 1px solid #3060ff;
          color: #3060ff;
          margin-bottom: 8px;
          cursor: pointer;
          padding: 2px 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .select {
          color: #fff;
          background: #3060ff;
        }

        li:nth-of-type(4n) {
          margin-right: 0;
        }
      }
    }

    .workOrder-box {
      width: 170px;
      border: 1px solid #d9d9d9;
      padding: 10px 16px;
      margin-right: 16px;

      &:hover {
        cursor: pointer;
      }

      p {
        font-size: 12px;
        color: #999999;
        line-height: 18px;
        padding-left: 25px;
      }
    }

    .selected {
      border: 1px solid #3060ff;
      background: #fff;
      box-shadow: 11px 11px 25px 0px rgba(0, 0, 0, 0.13);
    }

    .tip {
      font-size: 12px;
      color: #999999;
      letter-spacing: 1px;
      line-height: 18px;
      margin-top: 8px;
    }
  }
}
</style>
<style lang="scss">
.workOrder-main {
  text-align: center;

  .h-form {
    display: inline-block;
    text-align: left;

    .h-form-item {
      margin-bottom: 20px;

      .h-form-item-content {
        width: 540px;

        .h-input {
          border-radius: 2px;
          height: 36px;
          padding: 5px 16px;
          font-size: 14px;
        }

        .h-select-selection {
          border-radius: 2px;
          height: 36px;

          .icon-unfold:before {
            background-color: rgb(217, 217, 217);
            color: #fff;
          }

          .h-select-arrow {
            font-size: 20px;
            line-height: 16px;
            right: 12px;
          }

          .h-select-placeholder,
          .h-select-selected-value {
            font-size: 14px;
            height: 36px;
            line-height: 36px;
            padding-left: 16px;
          }
        }

        .h-select-dropdown {
          border-radius: 2px;

          .h-select-item {
            font-size: 14px;
          }
        }
      }
    }

    & > .h-form-item:nth-last-child(2) {
      margin-bottom: 40px;
    }

    .h-btn {
      border-radius: 2px;
      width: 152px;
      height: 36px;
      line-height: 22px;
    }

    .h-form-item-label {
      padding-right: 16px;
      font-size: 14px;
      font-weight: 600;
    }

    .h-form-item-label {
      line-height: 36px;
    }

    :first-child {
      .h-form-item-label {
        line-height: 54px;
      }
    }

    .h-radio-group {
      display: flex;
      justify-content: flex-start;

      .h-radio-wrapper {
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/submitWorkOrder.vue